import { ThemeContext } from "app/uicomponents/macrocomponents/RootLayout";
import * as React from "react";
import { useContext } from "react";

interface SVGProps extends React.SVGProps<SVGSVGElement> {}

const HexagonMetricsIcon: React.FC<SVGProps> = (props) => {
  const { isDarkMode } = useContext(ThemeContext);
  const finalColor = props?.fill?.trim() ? props?.fill?.trim() : isDarkMode ? "#FFFFFF" : "#00132E";

  return (
    <svg
      width={14}
      height={16}
      viewBox="0 0 14 16"
      xmlns="http://www.w3.org/2000/svg"
      style={{ color: finalColor }}
      {...props}
    >
      <path
        d="M7 1.0006C7.09367 1.0006 7.1857 1.02561 7.26668 1.07356L12.7517 4.30133C12.9161 4.39805 13.0183 4.57858 13.0183 4.77244V11.228C13.0183 11.4218 12.9161 11.6024 12.7517 11.6991L7.26668 14.9269C7.1857 14.9744 7.09326 14.9998 7 14.9998C6.90674 14.9998 6.8143 14.9748 6.73332 14.9269L1.24833 11.6987C1.08391 11.6019 0.981652 11.4214 0.981652 11.2276V4.77244C0.981652 4.57858 1.08391 4.39805 1.24833 4.30133L6.73332 1.07356C6.8143 1.02603 6.90674 1.0006 7 1.0006ZM7 0C6.73823 0 6.47686 0.0687912 6.24249 0.206791L0.757509 3.43456C0.288769 3.71056 0 4.22044 0 4.77244V11.228C0 11.78 0.288769 12.2899 0.757509 12.5654L6.24249 15.7932C6.47686 15.9312 6.73864 16 7 16C7.26136 16 7.52314 15.9312 7.75751 15.7932L13.2425 12.5654C13.7112 12.2894 14 11.7796 14 11.228V4.77244C14 4.22044 13.7112 3.71097 13.2425 3.43497L7.75751 0.206791C7.52314 0.0687912 7.26136 0 7 0Z"
        fill="currentColor"
      />
      <path d="M5.03998 7.71381H3.73315V11.3981H5.03998V7.71381Z" fill="currentColor" />
      <path d="M7.65363 5.6167H6.3468V11.3985H7.65363V5.6167Z" fill="currentColor" />
      <path d="M10.2673 4.42639H8.96045V11.3985H10.2673V4.42639Z" fill="currentColor" />
    </svg>
  );
};

export default HexagonMetricsIcon;
